export default () => ({
  trigger: {
    name: 'reviews.view_reviews',
    params: {},
  },
  config: {
    event: {
      name: 'view_content',
      params: {
        sub_feature: null,
        content: null,
        index: null,
        total_indices: null,
      },
    },
    nonInt: true,
  },
});
